import { useTranslation } from "@aviv-unified-frontend/runtime/i18n";
import { CDP_I18N_NAMESPACE } from "@/constants";
export const useI18n = () => {
    const { t } = useTranslation(CDP_I18N_NAMESPACE);
    return { t };
};
